import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Route, Routes, Navigate, Outlet } from "react-router-dom";
import "./index.css";
import "@fontsource/poppins";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/400-italic.css";
import Sidebar from "./layout/sidebar";
import Navbar from "./layout/navbar";
import Login from "./pages/login";
import Home from "./pages/home";
import AboutUs from "./pages/aboutus";
import Features from "./pages/features";
import Blog from "./pages/blog";
import AddBlog from "./pages/add-blog";
import Testimonial from "./pages/testimonials";
import AddTestimonial from "./pages/add-testimonial";
import Leads from "./pages/leads";
import FAQs from "./pages/faq";
import AddFaq from "./pages/add-faq";
import Footer from "./pages/footer";
import HowItWorks from "./pages/how-it-works";
import ContactUs from "./pages/contact-us";
import Pricing from "./pages/pricing";
import FeaturesDemo from "./pages/features-demo";
import Courses from "./pages/courses";
import Plans from "./pages/plans";
import AddPlan from "./pages/add-plan";
import FreeTrial from "./pages/free-trial";
import SubscribeLeads from "./pages/subscribe-leads";
import PlansList from "./pages/plans-list";
import DemoRequests from "./pages/demo-requests";
import QueryFormAdmin from "./pages/query-form";
import QueryFormResponses from "./pages/query-form-responses";
import CoachCourses from "./pages/coach-courses";

import { ContextProvider, useStore } from "./utils/context";
import "react-quill/dist/quill.snow.css";

function App() {
  return (
    <Router className="">
      <div className="App  ">
        <ContextProvider>
          <ToastContainer />
          <Routes>
            <Route path="/login" element={<NonAuthRoute />} />
            <Route path="/" element={<AuthLayout />}>
              <Route index element={<Navigate to="/home" replace />} />
              <Route path="/home" element={<Home />} />
              <Route path="/aboutus" element={<AboutUs />} />
              <Route path="/features" element={<Features />} />
              <Route path="/aboutus" element={<AboutUs />} />
              <Route path="/blogs" element={<Blog />} />
              <Route path="/add-blog" element={<AddBlog />} />
              <Route path="/testimonials" element={<Testimonial />} />
              <Route path="/testimonials/add" element={<AddTestimonial />} />
              <Route path="/leads" element={<Leads />} />
              <Route path="/faq" element={<FAQs />} />
              <Route path="/faq/add" element={<AddFaq />} />
              <Route path="/footer" element={<Footer />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/features-demo" element={<FeaturesDemo />} />
              <Route path="/courses" element={<Courses />} />
              <Route path="/plans" element={<Plans />} />
              <Route path="/add-plan" element={<AddPlan />} />
              <Route path="/free-trial" element={<FreeTrial />} />
              <Route path="/subscribe-leads" element={<SubscribeLeads />} />
              <Route path="/plans-list" element={<PlansList />} />
              <Route path="/demo-requests" element={<DemoRequests />} />
              <Route path="/query-form" element={<QueryFormAdmin />} />
              <Route path="/query-form-responses" element={<QueryFormResponses />} />
              <Route path="/coach-courses" element={<CoachCourses />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ContextProvider>
      </div>
    </Router>
  );
}

const AuthLayout = () => {
  const { isAuthenticated } = useStore();
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="dashboard-layout overflow-x-hidden">
      <Sidebar />
      <div className="main-content">
        <Navbar />
        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

const NonAuthRoute = () => {
  const { isAuthenticated } = useStore();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }
  return <Login />;
};

export default App;
